import { useNotify } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import { useEffect, useState } from 'react';

export function useMaintenanceMode(): boolean {
  const { showToast } = useNotify();
  const { t } = useTranslation();
  const [isInMaintenanceMode, setIsInMaintenanceMode] = useState(false);

  // If the app is in maintenance mode we want to show the maintenance page rather than render the app.
  useEffect(() => {
    const handler = (event: Event) => {
      const { detail } = event as CustomEvent;

      if (detail !== undefined) {
        showToast({ text: t(detail.messageKey), kind: 'danger' });
      } else {
        setIsInMaintenanceMode(true);
      }
    };

    window.addEventListener('feature-maintenance-mode', handler);

    return () => window.removeEventListener('feature-maintenance-mode', handler);
  }, [showToast, t]);

  return isInMaintenanceMode;
}
